import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function verifyEmailFormReducer(state = initialState.verifyEmailForm, action) {
    switch (action.type) {
        case types.VERIFY_EMAIL_SUCCESS:
            return {
                ...state,
                isVerifyEmailSuccessful: true,
                verifyEmailMessages: action.verifyEmailMessages
            };
        case types.VERIFY_EMAIL_ERROR:
            return {
                ...state,
                isVerifyEmailSuccessful: false,
                verifyEmailMessages: action.verifyEmailMessages
            };
        case types.LOAD_VERIFY_EMAIL_FORM_SUCCESS:
            return {
                ...state,
                isFormLoadSuccessful: true,
                verifyEmailFormData: action.verifyEmailFormData,
                verifyEmailMessages: []
            };
        case types.LOAD_VERIFY_EMAIL_FORM_ERROR:
            return {
                ...state,
                isFormLoadSuccessful: false,
                verifyEmailFormData: {},
                verifyEmailMessages: []
            };
        case types.RESET_VERIFY_EMAIL_FORM_STATE:
            return initialState.verifyEmailForm;
        default:
            return state;
    }
}
